export default {
    name: "item-listing",
    template: '#vue-item-listing',

    data() {
        return {}
    },

    props: {
        items: Array,
    },
}